import ReactApexChart from "react-apexcharts";
import { useMemo } from "react";

const getChartOptions = (categories = []) => ({
  chart: {
    type: "bar",
    toolbar: { show: false },
    animations: { enabled: true },
  },
  plotOptions: {
    bar: {
      borderRadius: 6,
      dataLabels: {
        position: "top",
      },
    },
  },
  dataLabels: {
    enabled: true,
    offsetY: -20,
    formatter: (val) => `${parseInt(val)}`,
    style: {
      fontSize: "12px",
      colors: ["#0f172a"],
    },
  },
  xaxis: {
    categories,
    labels: {
      rotate: -45,
      rotateAlways: true,
      style: {
        fontSize: "11px",
      },
    },
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  yaxis: {
    labels: {
      formatter: (value) => `${parseInt(value)}`,
    },
    title: {
      text: "Quantidade de consultas",
    },
  },
  tooltip: {
    y: {
      formatter: (value) => `${parseInt(value)} consultas`,
    },
  },
  grid: {
    borderColor: "#e5e7eb",
  },
  colors: ["#3b82f6"],
});

const HistoricoConsultasChart = ({
  paresMesAnoHistoricoConsultas = [],
  totaisHistoricoConsultas = [],
  title = "Histórico de Consultas",
  subtitle = "Consultas nos últimos meses",
}) => {
  const chartData = useMemo(() => {
    const options = getChartOptions(paresMesAnoHistoricoConsultas);

    const series = [
      {
        name: "Consultas",
        data: totaisHistoricoConsultas,
      },
    ];

    return { options, series };
  }, [paresMesAnoHistoricoConsultas, totaisHistoricoConsultas]);

  const isEmpty =
    !paresMesAnoHistoricoConsultas.length || !totaisHistoricoConsultas.length;

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <div className="mb-4">
        <p className="text-sm font-semibold text-gray-900">{title}</p>
        <p className="text-xs text-gray-500">{subtitle}</p>
      </div>

      {isEmpty ? (
        <p className="text-sm text-gray-500">Sem dados disponíveis</p>
      ) : (
        <div className="h-80">
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={320}
          />
        </div>
      )}
    </div>
  );
};

export default HistoricoConsultasChart;

